import {
  RecoilRoot,
  atom,
  selector,
  useRecoilState,
  useRecoilValue,
} from 'recoil';
import { recoilPersist } from 'recoil-persist'


// Control whether the hamburer menu icon was clicked or not. This state is
// needed by 'TopNavigation' an 'SideNavigation' components.
export const onHamburgerClickedState = atom({
    key: 'onHamburgerClicked', // unique ID (with respect to other atoms/selectors)
    default: false, // default value (aka initial value)
});

// Control what message to display at the top as a banner in the app.
export const topAlertMessageState = atom({
    key: 'topBannerAlertMessage',
    default: "",
});

// Control what type of message to display at the top as a banner in the app.
export const topAlertStatusState = atom({
    key: 'topBannerAlertStatus',
    default: "success",
});

// Note:
// https://github.com/polemius/recoil-persist

const { persistAtom } = recoilPersist()

export const currentUserState = atom({
    key: 'currentUser',
    default: null,
    effects_UNSTABLE: [persistAtom],
});

// --- Users --- //

// Control whether to show filters for the users list.
export const usersShowFilterState = atom({
    key: 'usersShowFilterState',
    default: false,
    effects_UNSTABLE: [persistAtom],
});

export const usersSearchTextState = atom({
    key: 'usersSearchTextState',
    default: "",
    effects_UNSTABLE: [persistAtom],
});

export const usersTrialStatusState = atom({
    key: 'usersTrialStatusState',
    default: "",
    effects_UNSTABLE: [persistAtom],
});

export const usersStatusState = atom({
    key: 'usersStatusState',
    default: "",
    effects_UNSTABLE: [persistAtom],
});

export const usersCreatedState = atom({
    key: 'usersCreatedState',
    default: 368,  // Last year
    effects_UNSTABLE: [persistAtom],
});

export const userDetailState = atom({
    key: 'userDetailState',
    default: {},  // Last year
    effects_UNSTABLE: [persistAtom],
});

// --- User Sessions --- //

export const userSessionsShowFilterState = atom({
    key: 'userSessionsShowFilterState',
    default: false,
    effects_UNSTABLE: [persistAtom],
});

export const userSessionsSessionTypeState = atom({
    key: 'userSessionsSessionTypeState',
    default: "",
    effects_UNSTABLE: [persistAtom],
});

export const userSessionsSortedByState = atom({
    key: 'userSessionsSortedByState',
    default: "completed_time,ASC",
    effects_UNSTABLE: [persistAtom],
});

// --- User Reports --- //

export const userReportsShowFilterState = atom({
    key: 'userReportsShowFilterState',
    default: false,
    effects_UNSTABLE: [persistAtom],
});

export const userReportsSortedByState = atom({
    key: 'userReportsSortedByState',
    default: "created,DESC",
    effects_UNSTABLE: [persistAtom],
});

// --- Session Templates --- //

export const sessionTemplatesShowFilterState = atom({
    key: 'sessionTemplatesShowFilterState',
    default: false,
    effects_UNSTABLE: [persistAtom],
});

export const sessionTemplatesSessionTypeState = atom({
    key: 'sessionTemplatesSessionTypeState',
    default: "",
    effects_UNSTABLE: [persistAtom],
});

export const sessionTemplatesSortedByState = atom({
    key: 'sessionTemplatesSortedByState',
    default: "created,DESC",
    effects_UNSTABLE: [persistAtom],
});
